import React from 'react'
import { disconnectFitness } from 'supporticon/api/fitness'
import { isRichTextEmpty } from '../../../../../lib/richText'

import Button from '../../../../ui/Button'
import Confirm from '../../../../ui/Confirm'
import Icon from 'constructicon/icon'
import Section from 'constructicon/section'

class DisconnectStrava extends React.Component {
  constructor () {
    super()
    this.state = { status: null }
  }

  render () {
    const { onChange, message, page, user } = this.props
    const { status } = this.state

    const defaultMessage = `
      <p>
        Disconnecting Strava will remove all activities that have been
        synced with your JustGiving fundraising page.
      </p>
      <p>
        If you are having an issue with syncing activities, please
        check out the
        <a href='https://help.justgiving.com/hc/en-us/sections/360005738198-Charity-Branded-Pages'>Support Guides</a>
        or contact the JustGiving team for assistance.
      </p>
    `

    return (
      <div>
        <Confirm
          tag={Button}
          width={18}
          message={isRichTextEmpty(message) ? defaultMessage : message}
          background='strava'
          cancelLabel='Cancel'
          confirmLabel='Disconnect'
          onConfirm={() =>
            Promise.resolve()
              .then(() => this.setState({ status: 'fetching' }))
              .then(() => disconnectFitness({ pageId: page.uuid, token: user.token }))
              .then(() => onChange())
              .catch(error => {
                this.setState({ status: 'failed' })
                return Promise.reject(error)
              })
          }>
          <Icon
            name={status === 'fetching' ? 'loading' : 'strava'}
            size={1.5}
            spin={status === 'fetching'}
          />
          <span>Disconnect from Strava</span>
        </Confirm>
        {status === 'failed' && (
          <Section
            background='danger'
            foreground='light'
            margin={{ t: 0.5 }}
            radius='small'
            spacing={{ y: 0.5, x: 1 }}>
            There was an unexpected error
          </Section>
        )}
      </div>
    )
  }
}

export default DisconnectStrava
